// rootReducer.js
import { combineReducers } from 'redux';
import {currentUserReducer} from './user_reducer';
import {shiftsReducer} from './shifts_reducer';

const rootReducer = combineReducers({
  user: currentUserReducer,
  shifts: shiftsReducer,
});

export default rootReducer;